import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_CABLE_SUBWAY_3K_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL } from '../OpticApiConfig';
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const Statistic = (user) => 
  {

  const [selectedCanton, setSelectedCanton] = useState('');
  const [resultCantonHouses, setCantonHouses] = useState([]);
  const [resultTotalHouses, setTotalHouses] = useState([]);
  const [resultCable, setResultCable] = useState([]);
  const [resultCableAccount, setResultCableAccount] = useState([]);
  const [resultComponent, setResultComponent] = useState({});
  const [error, setError] = useState(null);  
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
    
      const newDate = new Date(selectedDate);
      newDate.setDate(newDate.getDate() + 1); // Добавляем 1 день


      const formattedDate = newDate.toISOString().split("T")[0];

      const response = await axios.get(`${GET_STATISTICS_CABLE_EXCEL_API_URL}`, {
        params: { date: formattedDate },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, 
      });

      const responseAccount = await axios.get(`${GET_STATISTICS_ACCOUNT_EXCEL_API_URL}`, {
        params: { date: formattedDate },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, 
      });

      // Переименование ключей
      const formattedData = responseAccount.data.map(item => ({
        "Логин": item.username,
        "Муфта": item.couplingCount,
        "Фоб": item.fobCount,
        "Опора": item.pillarCount,
        "Пон-бокс": item.ponBoxCount,
        "Колодец": item.wellCount,
        "Воздушка": item.cableAirCount,
        "Подземка": item.cableSubwayCounts,
        "Доки  подземка": item.cableDocumentCount,
        "Всего кабеля": item.cableTotalCount,
      }));

     const responseSubway3k = await axios.get(`${GET_STATISTICS_CABLE_SUBWAY_3K_EXCEL_API_URL}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, 
      });

      // Переименование ключей
      const subway3kData = responseSubway3k.data.map(item => ({
        "Округ": item.canton,
        "3K узлов": item.quantity3k,
        "Кол. подземок": item.quantitySubway,
        "Кол. воздушек": item.quantityAir,
      }));
 
      if (!response.data || response.data.length === 0) {
        alert("Нет данных за выбранную дату");
        setLoading(false);
        return;
      }

    const worksheet = XLSX.utils.json_to_sheet(response.data.resultCanton);

    const worksheet2 = XLSX.utils.json_to_sheet(response.data.resultCity);

    const worksheetAccount = XLSX.utils.json_to_sheet(formattedData);

    const worksheetSubway3k = XLSX.utils.json_to_sheet(subway3kData);
    
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, "Статистика_округ");
XLSX.utils.book_append_sheet(workbook, worksheet2, "Статистика_город");
XLSX.utils.book_append_sheet(workbook, worksheetAccount, "Статистика по аккаунтам");
XLSX.utils.book_append_sheet(workbook, worksheetSubway3k, "Оптика ранг 3К");


const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
const newDate2 = new Date(selectedDate);
newDate.setDate(newDate2.getDate() - 1); // Вычитаем 1 день

// Форматируем дату в ISO-формате и извлекаем только дату
const formattedDateMinusOne = newDate2.toISOString().split("T")[0];

saveAs(blob, `Статистика_${formattedDateMinusOne}.xlsx`);

    } catch (error) {
      console.error("Ошибка загрузки данных:", error);
      alert("Ошибка загрузки данных");
    }
    setLoading(false);
  };
  

   useEffect(() => {
        loadingCanton(setCanton); 
      }, []); 
  

   // Обработчик нажатия на кнопку
   const handleButtonClick = async () => {
    if (!selectedCanton) {
      setError('Пожалуйста, выберите округ.');
      return;
    }

    try {
      setError(null);  // Сброс ошибки перед загрузкой данных
  
      // Параллельное выполнение запросов с использованием Promise.all
      const responses = await Promise.all([
        axios.get(GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, {
          headers: { Authorization: `Bearer ${token}` },
          params: { canton: selectedCanton }  // Только canton
        }),
        axios.get(GET_STATISTICS_CABLE_ACCOUNT_API_URL, {
          headers: { Authorization: `Bearer ${token}` },
          params: { authorId: user.user }  // Только authorId
        }),
        axios.get(GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL, {
          headers: { Authorization: `Bearer ${token}` },
          params: { authorId: user.user }  // Только authorId
        }),
        axios.get(GET_STATISTICS_CABLE_CANTON_API_URL, {
          headers: { Authorization: `Bearer ${token}` },
          params: { canton: selectedCanton }  // Только canton
        })
      ]);
  
      // Обновление состояний только один раз после получения всех данных
      const [housesResponse, cableAccountResponse, infrastructureResponse, cableCantonResponse] = responses;
      
      setCantonHouses(housesResponse.data.query);
      setTotalHouses(housesResponse.data.total);
      setResultCableAccount(cableAccountResponse.data);
      setResultComponent(infrastructureResponse.data);
      setResultCable(cableCantonResponse.data);
      setIsVisible(true);

    } catch (error) {
      console.error('Error fetching data', error);
      setError('Ошибка при загрузке данных. Пожалуйста, попробуйте позже.');
    }
  };


 

  return (
    <>
    
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
    <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px",textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>Статистика</label>
      <Select
            className="selectSearchDrawer"
            options={canton.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="Округ"
            onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={handleButtonClick} 
          >
            Загрузить
          </button>

          <div className='address-summary'
            style={{
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
              paddingLeft: "20px",
              paddingRight: "20px",
              marginLeft: "100px",  
              float: "right", 
              display: "flex",
              borderRadius: "10px",
              flexDirection: "row", 
              alignItems: "center", 
            }}
          >
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Выберите дату"
            className="inputDescriptionModal"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            shouldCloseOnSelect={false}
            open={false}
          />

          <button className='buttonAutoTopology' onClick={handleDownload} disabled={loading} style={{ marginLeft: "10px",  marginTop: "0px" }}>
            {loading ? "Скачивание..." : "Скачать Excel"}
          </button>
        </div>
        
      </div>
      <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
    </div>
   
{isVisible && (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>

      {/* Актуализация домов */}
      <div  className="scroll-container" style={{ flex: 1, marginTop: '0px', maxWidth:"400px",   height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>       
        <table className="results-table"> 
          <thead>
          <tr>
          <td colSpan="5" 
      style={{
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',      
        backgroundImage: 'linear-gradient(to right, rgb(56, 56, 56), #434343)',
      }}>
         
   {resultCable.city} | Домов: {resultTotalHouses.houseCount} | Внесено: {resultTotalHouses.actualize}
   </td>
          </tr>
            <tr>
              <th>Регион</th>
              <th>Ветка</th>
              <th>Домов</th>
              <th>Внесено</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {resultCantonHouses.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              resultCantonHouses.map((item, index) => {
                const percentage = item.houseCount > 0 
                  ? ((item.actualize / item.houseCount) * 100).toFixed(2) + "%" 
                  : "0%"; 
                return (
                  <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(51, 51, 51)'}}>
                    <td>{item.region}</td>
                    <td >
                      {item.area}
                    </td>
                    <td >
                      {item.houseCount}
                    </td>
                    <td >
                      {item.actualize}
                    </td>
                    <td 
                      className="total-cell" 
                      style={{ 
                        color: item.total === 0 
                          ? '#e0656f' 
                          : percentage === "100.00%" 
                            ? '#5bcc87' 
                            : percentage >= "61.00%" 
                              ? '#ffa500' 
                              : '#e0656f' 
                      }}
                    >
                      {percentage}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

        {/* CABLE CANRON */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "0px", gap: "10px"}}>
          <div  style={{ maxWidth: "400px", overflowY: 'auto', paddingBottom: '10px' ,  paddingRight: "10px" }}>
            <table className="results-table">
              <thead>
                <tr>
                  <td colSpan="4" style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
                    textShadow: '2px 2px 4px rgb(39, 39, 39)'
                  }}>
                  Всего кабеля
                  </td>
                </tr>
                <tr>
                  <th>Округ</th>
                  <th>Подземка</th>
                  <th>Воздушка</th>
                  <th>Всего</th>
                </tr>
              </thead>
              <tbody>
                {resultCable ? (
                  <tr>
                    <td style={{textShadow: '2px 2px 4px rgb(39, 39, 39)'}}>{resultCable.city}</td>
                    <td style={{ color: resultCable.subway === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                      {resultCable.subway}
                    </td>
                    <td style={{ color: resultCable.air === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                      {resultCable.air}
                    </td>
                    <td className="total-cell" style={{ color: resultCable.total === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                      {resultCable.total}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="4" className="no-data">Нет данных для отображения</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

      {/* Статистика по аккаунту кабеля */}
        <div  style={{ maxWidth: "400px", overflowY: 'auto', paddingBottom: '10px', paddingRight: "10px" }}>
          <table className="results-table" style={{width: "330px"}}>
            <thead>
              <tr>
                <td colSpan="4" style={{
                  textAlign: 'center',
                  fontSize: '14px',
                  backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
                  textShadow: '2px 2px 4px rgb(39, 39, 39)'
                }}>
                  Статистика по аккаунту <span style={{ color: 'orange' }}>{user.user}</span>
                </td>
              </tr>
              <tr>
                <th>Аккаунт</th>
                <th>Кабеля всего</th>
              </tr>
            </thead>
            <tbody>
              {resultCableAccount ? (
                <tr>
                  <td style={{textShadow: '2px 2px 4px rgb(39, 39, 39)'}}>{user.user}</td>
                  <td className="total-cell" style={{ color: resultCableAccount === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                    {resultCableAccount}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="4" className="no-data">Нет данных для отображения</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>


   {/* Статистика по аккаунту компонентов */}
      <div style={{ flex: 1,  marginLeft:'30px', marginTop: '0px' }}>
        <table className="results-table">
          <thead>
           <tr>
          <td colSpan="6" style={{
            textAlign: 'center',
            fontSize: '14px',
            backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
            textShadow: '2px 2px 4px rgb(39, 39, 39)'
          }}>
             Статистика по аккаунту <span style={{ color: 'orange' }}>{user.user}</span>
          </td>
        </tr> 
            <tr>
              <th>Аккаунт</th>
              <th>Колодец</th>
              <th>Опора</th>
              <th>Фоб</th>
              <th>Муфта</th>
              <th>Понбокс</th>
            </tr>
          </thead>
         
          <tbody>
            {resultComponent && Object.keys(resultComponent).length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              <tr>
                <td style={{textShadow: '2px 2px 4px rgb(39, 39, 39)'}}>{user.user}</td>
                <td style={{ color: resultComponent.totalWell === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                  {resultComponent.totalWell}  
                </td>
                <td style={{ color: resultComponent.totalPillar === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                  {resultComponent.totalPillar}
                </td>
                <td style={{ color: resultComponent.totalFob === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                  {resultComponent.totalFob}
                </td>
                <td style={{ color: resultComponent.totalCoupling === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                  {resultComponent.totalCoupling}
                </td>
                <td style={{ color: resultComponent.totalPonBox === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
                  {resultComponent.totalPonBox}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
  </div>
       )}
      </>
  );
};

export default Statistic;
